/* eslint-disable react-hooks/rules-of-hooks */
import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'umi';
import Filter from '@/pages/dashboard/components/NewFilter';
import { setBtnPointLog } from "@/pages/dashboard/utils/utils";
import { getDateDefault } from '../../utils/dateUtils';
import { FORM_MAP } from '@/pages/dashboard/pages/overview/_config/constant';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:setFilterLoading 筛选器loading设置，透传到筛选器组件内部，获取到筛选器列表时区等数据之后，设置为false，测试才可进行页面和组件中的接口调用
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

const firstWordUpper = (str: string) => {
  if (!str) return str;
  const firstLetter = str.charAt(0);
  const firstLetterCap = firstLetter.toUpperCase();
  const remainingLetters = str.slice(1);
  return firstLetterCap + remainingLetters === 'Date' ? 'Day' : firstLetterCap + remainingLetters;
};

// 筛选器路径
const FILTER_PATH = 'engagement/active/activeDegree';

const activeDegreeFilter = (props: any) => {
  const { filterConfirm, filterReset, buttonLogConfig, setFilterLoading, filterInit,
    openSticky = false, children, isHaveFilterSave, timeZone = 0 } = props;
  const dispatch = useDispatch();
  // daily筛选器继承逻辑
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新
  // 初始可能为undefied,在此加兜底
  const { seasonInfo } = useSelector((state: any) =>
    ({
      seasonInfo: state?.dashboardSetting?.gameConfig?.season_info || { date: [], week: [], month: [] },
    })
  );

  const handleRangePicker = () => {
    setTimeout(() => {
      dispatch({
        type: 'rangePikerLeft/setRangePickerLeftData',
        payload: {
          data: [
            {
              dateFilterKey: "normal",
              tabActiveTab: "event",
              selectedEventId: "all",
              eventSelectedChild: ""
            }
          ],
        },
      });
    }, 500);
  };

  // commonDateDefault(timeZone, seasonInfo)
  // 设置inputList
  const [inputList] = useState([
    {
      type: 'rangeDate',
      key: 'rangeTime',
      default: {
        type: 'week',
        value: getDateDefault({ timeType: 'week', timeZone, startNum: 1, endNum: 1 }),
      },
      componentDefault: {
        week: getDateDefault({ timeType: 'week', timeZone, startNum: 1, endNum: 1 }),
        month: getDateDefault({ timeType: 'month', timeZone, startNum: 1, endNum: 1 }),
      },
      typeList: ['week', 'month'],
      extraShortcut: seasonInfo,
      singleMonth: true,
    },]);

  const handleConfirm = (value: any) => {
    filterValueRef.current = value;
    filterConfirm?.({
      ...value,
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
      timeType: firstWordUpper(value?.rangeTime?.type),
      [FORM_MAP.RANGE_TIME_DIFF]: false,
    });
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, value);
  };

  const handleReset = (value: any) => {
    filterValueRef.current = value;
    filterReset?.({
      ...value,
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
      timeType: firstWordUpper(value?.rangeTime?.type),
      [FORM_MAP.RANGE_TIME_DIFF]: true,
    });
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, value, true);
    handleRangePicker();
  };

  const handleInit = (value: any, _: any, isHaveExtendFIlter: boolean) => {
    filterValueRef.current = value;
    filterInit?.({
      ...value,
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
      timeType: firstWordUpper(value?.rangeTime?.type),
      [FORM_MAP.RANGE_TIME_DIFF]: !isHaveExtendFIlter,
    });
    setFilterLoading(false);
    handleRangePicker();
  };

  // const handleChange = (key: string, value: any) => {
  //   if (key === 'rangeTime') {
  //     filterValueRef.current = {
  //       ...filterValueRef.current,
  //       [key]: {
  //         type: value.type,
  //         value: value.value,
  //       },
  //     };
  //   }
  // };

  return (
    <Filter
      config={props.config}
      openSticky={openSticky}
      path={FILTER_PATH}
      value={filterValueRef.current}
      latestDateType={''}
      inputList={inputList}
      onInit={handleInit}
      onConfirm={handleConfirm}
      onReset={handleReset}
      // onChange={handleChange}
      isHaveFilterSave={isHaveFilterSave}
    >
      {children}
    </Filter>
  );
};

export default activeDegreeFilter;
